import type { CodeBlockLowlightOptions as TiptapCodeBlockOptions } from '@tiptap/extension-code-block-lowlight'
import { CodeBlockLowlight as TiptapCodeBlock } from '@tiptap/extension-code-block-lowlight'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import ActionButton from '@/notebook/components/ActionButton.vue'
import type { GeneralOptions } from '@/notebook/type'
import CodeBlockView from './components/CodeBlockView.vue'

export type CodeBlockOptions = {} & TiptapCodeBlockOptions & GeneralOptions<CodeBlockOptions>

export const CodeBlock = TiptapCodeBlock.extend<CodeBlockOptions>({
  addOptions() {
    return {
      ...this.parent?.(),
      language: 'auto',
      button: ({ editor, t }) => ({
        component: ActionButton,
        componentProps: {
          action: () => editor.commands.toggleCodeBlock(),
          isActive: () => editor.isActive('codeBlock') || false,
          disabled: !editor.can().toggleCodeBlock(),
          icon: 'Code2',
          tooltip: t('editor.codeblock.tooltip'),
        },
      }),
    }
  },
  addNodeView() {
    return VueNodeViewRenderer(CodeBlockView)
  },
})
